import { createVueUi } from "@lunagoai/vue-ui";
import {
  AlertTriangle,
  BarChart3,
  ChevronDown,
  CreditCard,
  Database,
  Download,
  FileText,
  Info,
  LayoutDashboard,
  LogIn,
  LogOut,
  Menu,
  Pencil,
  Plus,
  RefreshCw,
  Save,
  Search,
  Settings,
  ShoppingCart,
  Trash2,
  Truck,
  Upload,
  Users,
  X,
} from "lucide-vue-next";
import "@lunagoai/vue-ui/style.css";
import "@lunagoai/vue-shell-ui/style.css";
import "@lunagoai/vue-file-ui/style.css";
import "@lunagoai/vue-media-ui/style.css";
import "@lunagoai/vue-markdown-ui/style.css";

const icons = {
  AlertTriangle,
  BarChart3,
  ChevronDown,
  CreditCard,
  Database,
  Download,
  FileText,
  Info,
  LayoutDashboard,
  LogIn,
  LogOut,
  Menu,
  Pencil,
  Plus,
  RefreshCw,
  Save,
  Search,
  Settings,
  ShoppingCart,
  Trash2,
  Truck,
  Upload,
  Users,
  X,
};

export const vueUi = createVueUi({
  icons,
  theme: {
    light: {
      primary: "#155e9c",
      primaryLight: "#2f7fbe",
      primaryHover: "#0f4c80",
      surface: "#ffffff",
      surfaceMuted: "#f4f7fa",
      surfaceElevated: "#ffffff",
      surfaceInverse: "#172437",
      text: "#172437",
      textMuted: "#526173",
      textDim: "#8a98a8",
      border: "#d9e1e9",
      borderStrong: "#b8c5d2",
      focus: "#2f7fbe",
      success: "#0f9f78",
      warning: "#d68116",
      danger: "#d94b4b",
      info: "#2f7fbe",
    },
    dark: {
      primary: "#4e9bea",
      primaryLight: "#79b7f4",
      primaryHover: "#357fc9",
      surface: "#172437",
      surfaceMuted: "#101b2a",
      surfaceElevated: "#203149",
      surfaceInverse: "#ffffff",
      text: "#f4f8fc",
      textMuted: "#b8c7d8",
      textDim: "#8b9caf",
      border: "#30455d",
      borderStrong: "#4e667f",
      focus: "#79b7f4",
      success: "#70d6b0",
      warning: "#f3c36d",
      danger: "#ff8b8b",
      info: "#79b7f4",
    },
  },
});
